import React from "react";
import { useNode } from "@craftjs/core";
import { css } from "@emotion/react";
import { defaultCssStyles } from "../..";
import { Resizer } from "../Resizer";

export interface IBuilderBlockProps {
  ref?: any;
  backgroundColor?: Record<"r" | "g" | "b" | "a", number>;
  backgroundImage?: string;
  color?: Record<"r" | "g" | "b" | "a", number>;
  flexDirection?: "row" | "column";
  alignItems?: string;
  justifyContent?: string;
  gap?: string;
  flexGrow?: boolean;
  flexShrink?: boolean;
  fillSpace?: string;

  width?: string;
  minWidth?: string;
  maxWidth?: string;
  height?: string;
  minHeight?: string;
  maxHeight?: string;

  padding?: string[];
  margin?: string[];
  marginTop?: number;
  marginLeft?: number;
  marginBottom?: number;
  marginRight?: number;
  shadow?: number;
  children?: React.ReactNode;
  radius?: number;

  overflow?: string;
  position?: string;
  left?: string;
  top?: string;
  zIndex?: number;
}

export const BuilderBlock: React.FC<
  React.PropsWithChildren<IBuilderBlockProps>
> = ({
  children,
  backgroundColor,
  color,
  backgroundImage,
  overflow,
  margin,
  padding,
  width,
  height,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  position,
  left,
  top,
  zIndex,
  flexDirection,
  alignItems,
  justifyContent,
  gap,
  flexGrow,
  flexShrink,
  ...rest
}) => {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <div
      //propKey={{ width: "width", height: "height" }}
      //resizeHandles={["right", "bottom"]}
      ref={connect as any}
      css={[
        defaultCssStyles(rest),
        css`
          display: flex;
          flex-direction: ${flexDirection ? flexDirection : "column"};
          align-items: ${alignItems
            ? flexDirection == "column"
              ? justifyContent
              : alignItems
            : null};
          justify-content: ${justifyContent
            ? flexDirection == "column"
              ? alignItems
              : justifyContent
            : null};
          gap: ${gap ? gap : null};
          position: relative;
          /* flex-shrink: 0; */
          box-sizing: border-box;
          line-height: normal;
          /* flex-grow: ${flexGrow !== undefined
            ? `${flexGrow}!important`
            : null};
          flex-shrink: ${flexShrink !== undefined
            ? `${flexShrink}!important`
            : null}; */

          width: ${width};
          height: ${height};
          margin: ${margin
            ? `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`
            : null};
          padding: ${padding
            ? `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`
            : null};
          min-width: ${minWidth};
          max-width: ${maxWidth};
          min-height: ${minHeight};
          max-height: ${maxHeight};

          color: ${color ? `rgba(${Object.values(color)})` : null};

          background-color: ${backgroundColor
            ? `rgba(${Object.values(backgroundColor)})`
            : null};
          background-image: ${backgroundImage
            ? `url(${backgroundImage})`
            : null};
          overflow: ${overflow ?? null};
          position: ${position ?? null};
          left: ${left ?? null};
          top: ${top ?? null};
          z-index: ${zIndex ?? 1};
        `,
      ]}
      {...rest}
    >
      {children}
    </div>
  );
};

BuilderBlock.displayName = "builder-block";
